import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const colors = {
  primary: "#0a4a8e",
  success: "#28a745",
  warning: "#ffc107",
  danger: "#dc3545",
};

const VChartStyle = styled.div`
  height: ${props => props.height || "300px"};
  width: ${props => props.width || "100%"};
  display: flex;  
  overflow-y: scroll;
  overflow-x: hidden;
  background-color: #f5f5f5;
  border-radius: 4px;
  position: relative;
  flex: 0 0 100%;
`;

export const VerticalBarChart = (props) => {

  const { t } = useTranslation();
  
  const renderTooltip = (d) => {
    return d.filial + ": " + d.onlate + " " + t('INCONSISTENT.ON_LATE') + ", " + d.ontime + " " + t('INCONSISTENT.ON_TIME') + ", " + d.pending + " " + t('INCONSISTENT.PENDING');
  }
  
  let data = props.data;
  const max = Math.max(Math.max(...data.map(o => o.onlate)),
  Math.max(...data.map(o => o.ontime)),
  Math.max(...data.map(o => o.pending)));
  
  let orderedData = [].concat(data);
  if (props.orderGroup)
  {
    orderedData = [].concat(data)
      .sort((a, b) => a.regional > b.regional ? 1 : -1);
  }

  const regionals = [];
  orderedData.map(dt => {
    if (regionals.indexOf(dt.regional) === -1) {
      regionals.push(dt.regional)
    }
  });

  return (
    <div>
    <div style={{display: "flex", gap: "5px", marginBottom: "10px", float: "right"}}>
      <div style={{background: colors.primary, width: "15px", height: "15px", borderRadius: "3px", marginLeft: "5px"}}></div><span style={{lineHeight: "15px"}}>{t('INCONSISTENT.ON_LATE')}</span>
      <div style={{background: colors.success, width: "15px", height: "15px", borderRadius: "3px", marginLeft: "5px"}}></div><span style={{lineHeight: "15px"}}>{t('INCONSISTENT.ON_TIME')}</span>
      <div style={{background: colors.danger, width: "15px", height: "15px", borderRadius: "3px", marginLeft: "5px"}}></div><span style={{lineHeight: "15px"}}>{t('INCONSISTENT.PENDING')}</span>
    </div>
    <VChartStyle>
      {props.groupLegend && <div style={{height: data.length*70, width: "30px"}}> 
        {regionals.map(r =>
          <div style={{height: data.filter(x => x.regional == r).length*70, border: "solid", borderRight: "none", writingMode: "vertical-rl", textOrientation:"mixed", display: "flex", justifyContent: "center", alignItems: "center"}}>Reg. {r}</div>
        )}   
      </div>}
      <div style={{height: "100%", width: props.groupLegend ? "98%" : "100%"}}>
        {orderedData.map(d => 
          <div style={{display: "flex", height: "70px"}}>
            <div style={{display: "flex", justifyContent: "center", alignItems: "center", padding: "5px", width: "50px"}}>
              {d.filial}
            </div>
            <div title={renderTooltip(d)} style={{width: "100%", paddingTop: "10px", paddingBottom: "10px", borderLeft: "solid 1px", borderRight: "solid 1px", background: "repeating-linear-gradient(90deg, #AAA0 0 calc((100% - 5*1px)/5), #AAA  0 calc((100% - 5*1px)/5 + 1px))"}}>            
              <div style={{background: colors.primary, width: d.onlate*100/max+"%", height: "33%", margin: "1px", marginLeft: "0px"}}></div>
              <div style={{background: colors.success, width: d.ontime*100/max+"%", height: "33%", margin: "1px", marginLeft: "0px"}}></div>
              <div style={{background: colors.danger, width: d.pending*100/max+"%", height: "33%", margin: "1px", marginLeft: "0px"}}></div>
            </div>
          </div>  
        )}        
      </div>
      
    </VChartStyle>
    <div style={{marginLeft: props.groupLegend ? "80px" : "50px", marginRight: "15px", display: "flex", textAlign: "right", position: "relative"}}>
        <div style={{position: "absolute", left: "-10px"}}>0</div>
        <div style={{width: "20%"}}>{(max*0.2).toFixed(1)}</div>
        <div style={{width: "20%"}}>{(max*0.4).toFixed(1)}</div>
        <div style={{width: "20%"}}>{(max*0.6).toFixed(1)}</div>
        <div style={{width: "20%"}}>{(max*0.8).toFixed(1)}</div>
        <div style={{width: "20%"}}>{(max).toFixed(1)}</div>
      </div>
    </div>
  );
};
